const withApollo = (Component) => Component;
export default withApollo;
